import { getEBankruptcyTypeList } from '@if/core/types'
import { formatIsoDate } from '@if/core/utils'
import { Divider, Grid } from '@mui/material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { InputTextField, SelectComponent } from '../../../components'
import { Bankruptcy } from '../../../data/types/CreditReportSchema'

interface Props {
  bankruptcy: Bankruptcy
}

const ReportedBankruptcy = ({ bankruptcy }: Props) => {
  const { t } = useTranslation()

  const bankruptcyTypeOptions = useMemo(
    () =>
      getEBankruptcyTypeList().map((item) => ({
        label: t(`EBankruptcyType.${item}`, { ns: 'enum' }),
        value: item,
      })),
    [t],
  )

  return (
    <>
      <Grid container spacing={2} sx={{ mt: 2 }} size={12}>
        <Grid
          size={{
            xs: 12,
            md: 2,
          }}
        >
          <InputTextField label="Date" value={formatIsoDate(new Date(bankruptcy.filedD ?? ''))} disabled />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 1.5,
          }}
        >
          <InputTextField
            label={t('browseCreditApplications.dataGridColumnHeaders.amount')}
            value={bankruptcy.liabilityAmount}
            disabled
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 3,
          }}
        >
          <SelectComponent
            items={bankruptcyTypeOptions}
            label={t('browseCreditApplications.dataGridColumnHeaders.bankruptcyType')}
            value={bankruptcy.intentCode}
            disabled
          />
        </Grid>
        <Grid
          size={{
            xs: 11,
            md: 3,
          }}
        >
          <InputTextField
            label={t('browseCreditApplications.dataGridColumnHeaders.TrusteeName')}
            value={bankruptcy.trusteeName}
            disabled
          />
        </Grid>
        <Grid
          size={{
            xs: 11,
            md: 2,
          }}
        >
          <InputTextField
            label={t('browseCreditApplications.dataGridColumnHeaders.CaseNumber')}
            value={bankruptcy.caseNumber}
            disabled
          />
        </Grid>
      </Grid>
      <Divider />
    </>
  )
}

export default ReportedBankruptcy
